import type { ThemeColors } from "./theme-colors.type";

export const THEME_COLORS: ThemeColors = {
  primary: {
    1: "#e8e8ea",
    2: "#b8b7bf",
    3: "#9595a0",
    4: "#656475",
    5: "#47465a",
    6: "#191831",
    7: "#17162d",
    8: "#121123",
    9: "#0e0d1b",
    10: "#0b0a15",
  },
  highlight: {
    1: "#fff4ea",
    2: "#ffddbd",
    3: "#ffcc9d",
    4: "#ffb571",
    5: "#ffa755",
    6: "#ff912b",
    7: "#e88427",
    8: "#b5671f",
    9: "#8c5018",
    10: "#6b3d12",
  },
  grey: {
    1: "#eeeeee",
    2: "#cccccc",
    3: "#b3b3b3",
    4: "#909090",
    5: "#7a7a7a",
    6: "#595959",
    7: "#515151",
    8: "#3f3f3f",
    9: "#313131",
    10: "#252525",
  },
  green: {
    2: "#cee9da",
    4: "#96d0af",
    6: "#62b988",
    8: "#468361",
  },
  red: {
    2: "#f0ccc6",
    4: "#de9083",
    6: "#cd5946",
    8: "#923f32",
  },
  blue: {
    1: "#ebeef3",
    2: "#b0d3e2",
    4: "#54a1c0",
    6: "#0072a1",
    8: "#005172",
  },
  altGreen: {
    4: "#b5dda7",
    6: "#91cc7b",
    8: "#679157",
  },
  status: {
    info: "#1677ff",
    success: "#52c41a",
    warning: "#faad14",
    error: "#ff4d4f",
  },
  state: {
    neutral: "#cccccc",
    action: "#0072a1",
    waiting: "#ffb571",
    warn: "#e8d76b",
    error: "#cd5946",
    ongoing: "#91cc7b",
    success: "#62b988",
    terminated: "#2f3628",
  },
  table: {
    activeFilter: "#1890ff",
  },
};

export const colorPrimary = THEME_COLORS.primary[6];
export const colorHighlight = THEME_COLORS.highlight[6];
export const colorText = THEME_COLORS.grey[6];
export const colorBodyBg = "#f0f2f5";
export const colorBorder = "#e8e8ea"; // Changes the default border color for most components (Layout, Button, ...)
export const colorBorderSecondary = "#f0f0f0"; // Changes lighter borders (e.g., Table, Card, Tabs, ...)
export const colorBlack = "#000";
export const colorAccent = "#FA8C16";
